import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IWallet, WALLET_TYPE } from '@libs/interfaces';
import {
  selectBalance,
  selectBaseCurrency,
  selectDisplayFiat,
  selectPendingDeposits,
  selectSpots,
  selectWallet,
  selectWithdraw,
} from '@libs/store/wallet/selectors';
import { setWallet, updateBalance } from '@libs/store/wallet/actions';
import { setCurrency, updateUserCurrency, updateUserWalletType } from '@libs/store/auth/actions';
@Injectable({
  providedIn: 'root',
})
export class StoreWalletService {
  constructor(private store: Store) {}
  /**
   * Selects the balance from the store.
   * @returns {Observable<number>} An observable containing the balance.
   */
  selectBalance() {
    return this.store.select(selectBalance);
  }

  /**
   * Selects the current wallet from the store.
   * @returns {Observable<IWallet>} An observable containing the selected wallet.
   */
  selectWallet(): Observable<IWallet> {
    return this.store.select(selectWallet);
  }

  /**
   * Selects the display fiat currency from the store.
   * @returns {Observable<string>} An observable containing the display fiat currency.
   */
  selectDisplayFiat() {
    return this.store.select(selectDisplayFiat);
  }

  /**
   * Selects the base currency from the store.
   * @returns {Observable<string>} An observable containing the base currency.
   */
  selectBaseCurrency() {
    return this.store.select(selectBaseCurrency);
  }

  /**
   * Selects the spots from the store.
   * @returns {Observable<any>} An observable containing the spots.
   */
  selectSpots() {
    return this.store.select(selectSpots);
  }

  /**
   * Sets the wallet in the store.
   * @param {IWallet} wallet - The wallet to set.
   */
  setWallet(wallet: IWallet) {
    this.store.dispatch(setWallet({ wallet }));
  }

  /**
   * Sets the currency in the store.
   * @param {IWallet} currency - The currency to set.
   */
  setCurrency(currency: IWallet) {
    this.store.dispatch(setCurrency({ currency }));
  }

  /**
   * Updates the balance in the store.
   * @param {number} balance - The balance to update.
   */
  updateBalance(balance: number) {
    this.store.dispatch(updateBalance({ balance }));
  }

  /**
   * Updates the user currency in the store.
   * @param {IWallet} wallet - The wallet containing the currency code to update.
   */
  updateUserCurrency(wallet: IWallet) {
    this.store.dispatch(updateUserCurrency({ code: wallet.code }));
  }

  /**
   * Updates the user wallet type in the store.
   * @param {WALLET_TYPE} wallet_type - The wallet type to update.
   */
  updateUserWalletType(wallet_type: WALLET_TYPE) {
    this.store.dispatch(updateUserWalletType({ wallet_type }));
  }
  selectPendingDeposits() {
    return this.store.select(selectPendingDeposits);
  }
  loadPendingDeposits() {
    this.store.dispatch({ type: '[wallet] Load pending deposits' });
  }
  selectWithdraw() {
    return this.store.select(selectWithdraw);
  }
}
